mutation AppendAdditionalApprovers($input: AppendAdditionalApproversInput!) {
  appendAdditionalApprovers(input: $input) {
    uuids
  }
}
